<template>
  <img
    v-if="src && !loadFailed"
    v-image-preview
    loading="lazy"
    :src="displaySrc"
    v-bind="$attrs"
    v-on="forwardListeners"
    @error="onImgError"
  />
</template>

<script>
import { ossThumb } from '@/utils/oss-image'

export default {
  name: 'OssImg',
  props: {
    src: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 96
    },
    quality: {
      type: Number,
      default: 80
    }
  },
  data () {
    return {
      loadFailed: false
    }
  },
  computed: {
    displaySrc() {
      return ossThumb(this.src, this.width, this.quality)
    },
    forwardListeners() {
      const listeners = { ...this.$listeners }
      delete listeners.error
      return listeners
    }
  },
  watch: {
    src() {
      this.loadFailed = false
    }
  },
  methods: {
    onImgError(e) {
      this.loadFailed = true
      this.$emit('error', e)
    }
  }
}
</script>
